import React from 'react';

import { Paper, Avatar, Box, Container, Grid, Link, Typography, makeStyles, Fade } from '@material-ui/core';
import { AssignmentInd, PeopleAlt } from '@material-ui/icons';
import { UnidadeContext } from '../../../Providers/unidadeProviders';

const styles = makeStyles((theme) => ({
    selecionado: {
        background: theme.palette.primary.dark,
        color: theme.palette.common.white,
    },
    naoSelecionado: {
        color: theme.palette.grey[600],
    },
}));

function Tipo() {

    const { state, setState, setChecked } = React.useContext(UnidadeContext);

    const classes = styles();

    const [check, setCheck] = React.useState(Boolean(state.tipo_atendimento));

    React.useEffect(() => {
        setChecked(Boolean(true));
    }, [setChecked]);

    const checkar = (value) => {
        setCheck(value);
        setState({ ...state, tipo_atendimento: Boolean(value) });
    };

    return (
        <Fade in={true} timeout={700}>
            <Container style={{ height: '40vh' }}>

                <Box display="flex" justifyContent="center">
                    <Box>
                        <Typography component="div" variant="overline"><Box fontWeight={600} fontSize={22}>Quem sou eu</Box></Typography>
                    </Box>
                </Box>
                <Box display="flex" justifyContent="center">
                    <Box mb={3}>
                        <Typography component="div" variant="caption">Informe para quem o atendimento será realizado.</Typography>
                    </Box>
                </Box>

                <Grid container spacing={2}>
                    <Grid item lg={6} md={6} sm={6} xs={12}>
                        <Link onClick={() => checkar(false)} style={{ cursor: 'pointer', textDecoration: 'none' }}>
                            <Paper className={check === false ? classes.selecionado : classes.naoSelecionado} variant="outlined">
                                <Box display="flex" justifyContent="space-between" alignItems="center" p={1}>
                                    <Box p={1}>
                                        <Avatar><PeopleAlt /></Avatar>
                                    </Box>
                                    <Box>
                                        <Box>
                                            <Typography component="div" variant="overline" align="right"><Box fontWeight={600} fontSize={13}>{"Público em Geral"}</Box></Typography>
                                        </Box>
                                        <Box>
                                            <Typography component="div" variant="caption" align="right"><Box fontSize={11}>{"Serviços destinados ao público em geral"}</Box></Typography>
                                        </Box>
                                    </Box>
                                </Box>
                            </Paper>
                        </Link>
                    </Grid>
                    <Grid item lg={6} md={6} sm={6} xs={12}>
                        <Link onClick={() => checkar(true)} style={{ cursor: 'pointer', textDecoration: 'none' }}>
                            <Paper className={check === true ? classes.selecionado : classes.naoSelecionado} variant="outlined">
                                <Box display="flex" justifyContent="space-between" alignItems="center" p={1}>
                                    <Box p={1}>
                                        <Avatar><AssignmentInd /></Avatar>
                                    </Box>
                                    <Box>
                                        <Box>
                                            <Typography component="div" variant="overline" align="right"><Box fontWeight={600} fontSize={13}>{"Servidor Municipal"}</Box></Typography>
                                        </Box>
                                        <Box>
                                            <Typography component="div" variant="caption" align="right"><Box fontSize={11}>{"Serviços destinados aos servidores públicos municipais"}</Box></Typography>
                                        </Box>
                                    </Box>
                                </Box>
                            </Paper>
                        </Link>
                    </Grid>
                </Grid>
            </Container>
        </Fade>
    );
}

export default Tipo;